import { FC } from 'react';
import { css, keyframes, useTheme } from '@emotion/react';

const iconStyle = css`
  overflow: visible;
`;

const rotateAnimation = keyframes`
  0% {
    transform-origin: 150px 41px;
    transform: translateY(-5px) rotate(0deg);
  };
  25% {
    transform-origin: 150px 41px;
    transform: translateY(-5px) rotate(10deg);
  };
  50% {
    transform-origin: 150px 41px;
    transform: translateY(-5px) rotate(0deg);
  };
  51% {
    transform-origin: 41px 41px;
    transform: translateY(-5px) rotate(0deg);
  };
  75% {
    transform-origin: 41px 41px;
    transform: translateY(-5px) rotate(-15deg);
  };
  100% {
    transform-origin: 41px 41px;
    transform: translateY(-5px) rotate(0deg);
  };
`;

const lidAnimatedStyle = css`
  animation: ${rotateAnimation} 2s infinite cubic-bezier(0.68, -0.6, 0.32, 1.6);
`;

export const Trash: FC<{ size?: number; strokeWidth?: number; color?: string; animate?: boolean }> = ({
  size = 36,
  strokeWidth = 12,
  color = undefined,
  animate = false,
}) => {
  const theme = useTheme();
  color = color || theme.color.grey[100];
  return (
    <svg viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg" width={size} height={size} css={iconStyle}>
      <path d="M114 78V126" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M78 78V126" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M150 42V156C150 157.591 149.368 159.117 148.243 160.243C147.117 161.368 145.591 162 144 162H48C46.4087 162 44.8826 161.368 43.7574 160.243C42.6321 159.117 42 157.591 42 156V42"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g css={[animate && lidAnimatedStyle]}>
        <path d="M162 42H30" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M126 42V30C126 26.8174 124.736 23.7652 122.485 21.5147C120.235 19.2643 117.183 18 114 18H78C74.8174 18 71.7652 19.2643 69.5147 21.5147C67.2643 23.7652 66 26.8174 66 30V42"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
